import axios from "axios";

/**
 * Interface para resposta da BrasilAPI
 */
interface BrasilAPICEP {
  cep: string;
  state: string;
  city: string;
  neighborhood?: string;
  street?: string;
  service: string;
}

/**
 * Busca dados de CEP usando múltiplas APIs como fallback.
 * Tenta primeiro BrasilAPI, depois ViaCEP, e por último Postmon.
 * @param cep CEP (8 dígitos, apenas números).
 * @returns Dados do CEP ou undefined em caso de erro.
 */
export async function BuscaCEP(cep: string): Promise<CEPCorreio | undefined> {
  if (cep.length !== 8) {
    return undefined;
  }

  const cepFormatado = `${cep.substring(0, 5)}-${cep.substring(5, 8)}`;

  // Tenta BrasilAPI primeiro (API pública brasileira)
  try {
    const brasilApiUrl = `https://brasilapi.com.br/api/cep/v1/${cep}`;
    const brasilApiResponse = await axios.get<BrasilAPICEP>(brasilApiUrl, {
      timeout: 10000,
      headers: {
        'Accept': 'application/json',
      },
    });

    if (brasilApiResponse.status === 200 && brasilApiResponse.data) {
      const data = brasilApiResponse.data;
      // Converter formato BrasilAPI para formato CEPCorreio
      return {
        cep: cepFormatado,
        logradouro: data.street || '',
        bairro: data.neighborhood || '',
        localidade: data.city || '',
        uf: data.state || '',
        erro: false,
      } as CEPCorreio;
    }
  } catch (error: any) {
  }

  // Fallback: ViaCEP
  try {
    const viaCepUrl = `https://viacep.com.br/ws/${cep}/json/`;
    const viaCepResponse = await axios.get<CEPCorreio>(viaCepUrl, {
      timeout: 10000,
      headers: {
        'Accept': 'application/json',
      },
    });

    if (viaCepResponse.status === 200 && viaCepResponse.data) {
      if (viaCepResponse.data.erro === true) {
        return { erro: true } as CEPCorreio;
      }
      return viaCepResponse.data;
    }
  } catch (error: any) {
  }

  // Fallback: Postmon
  try {
    const postmonUrl = `https://api.postmon.com.br/v1/cep/${cep}`;
    const postmonResponse = await axios.get<any>(postmonUrl, {
      timeout: 10000,
      headers: {
        'Accept': 'application/json',
      },
    });

    if (postmonResponse.status === 200 && postmonResponse.data) {
      const data = postmonResponse.data;
      return {
        cep: cepFormatado,
        logradouro: data.logradouro || data.endereco || '',
        bairro: data.bairro || '',
        localidade: data.cidade || data.municipio || '',
        uf: data.estado || data.estado_info?.sigla || '',
        erro: false,
      } as CEPCorreio;
    }
  } catch (error: any) {
    console.error('Todas as APIs de CEP falharam');
  }

  return undefined;
}

export class CEPCorreio {
  cep?: string;
  logradouro?: string;
  complemento?: string;
  unidade?: string
  bairro?: string
  localidade?: string
  uf?: string
  estado?: string
  regiao?: string
  ibge?: string
  gia?: string
  ddd?: string
  siafi?: string
  erro?: boolean;
}